import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { setSessionLostHandler } from './api/client';
import { useSessionStore } from './stores/session';
import './styles/base.css';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

// When a refresh fails the session is genuinely gone — clear it and route to
// login rather than leaving the UI in a half-authenticated state that fails one
// request at a time.
setSessionLostHandler(() => {
  useSessionStore().clear();
  void router.push({ name: 'login', query: { redirect: router.currentRoute.value.fullPath } });
});

app.mount('#app');
